export const EventTypeEnum = {
    UserLocGap: 'USER_LOC_GAP',
    UserBatterLevel: 'USER_BATTERY_LEVEL',
    TaskAcceptDelay: 'TASK_ACCEPT_DELAY',
    TaskLocFarArrived: 'TASK_LOC_FAR_ARRIVED',
    TaskEtaDelayCompleted: 'TASK_ETA_DELAY_COMPLETED',
    TaskSlaDelayCompleted: 'TASK_SLA_DELAY_COMPLETED',
    VehicleFreezerTemperature: 'VEHICLE_FREEZER_TEMPERATURE',
    TaskTemperatureBreach: 'TASK_TEMPERATURE_BREACH'
};

export const EventStatusEnum = {
    Ok: 'OK',
    Breached: 'BREACHED',
    Resolved: 'RESOLVED',
    Error: 'ERROR'
};
